const FORBIDDEN_COPY = {
  eyebrow: '403 · Not authorized',
  headline: 'You don’t have access to this screen',
  backToHome: 'Back to Home',
} as const;

export {
  FORBIDDEN_COPY,
};
